/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A ridgeline plot, or joyplot, is a series of density curves stacked vertically and slightly overlapping, used to compare how a distribution changes across an ordered set of groups.`)
};

const es_ridge_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un gráfico de cordillera, o joyplot, es una serie de curvas de densidad apiladas verticalmente y ligeramente superpuestas, utilizado para comparar cómo cambia una distribución a lo largo de un conjunto ordenado de grupos.`)
};

const de_ridge_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Ridgeline-Diagramm, oder Joyplot, ist eine Reihe von Dichtekurven, die vertikal gestapelt sind und sich leicht überlappen, verwendet um zu vergleichen, wie sich eine Verteilung über eine geordnete Gruppe von Kategorien verändert.`)
};

const nl_ridge_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een ridgeline plot, of joyplot, is een reeks dichtheidscurven die verticaal gestapeld zijn en elkaar licht overlappen, gebruikt om te vergelijken hoe een verdeling verandert over een geordende reeks groepen.`)
};

const fr_ridge_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un graphique en crêtes, ou joyplot, est une série de courbes de densité empilées verticalement et se chevauchant légèrement, utilisée pour comparer comment une distribution évolue selon un ensemble ordonné de groupes.`)
};

const it_ridge_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un grafico ridgeline, o joyplot, è una serie di curve di densità impilate verticalmente e leggermente sovrapposte, usato per confrontare come cambia una distribuzione lungo un insieme ordinato di gruppi.`)
};

const pt_br2_ridge_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um gráfico ridgeline, ou joyplot, é uma série de curvas de densidade empilhadas verticalmente e levemente sobrepostas, usado para comparar como uma distribuição muda ao longo de um conjunto ordenado de grupos.`)
};

const pt_ridge_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um gráfico ridgeline, ou joyplot, é uma série de curvas de densidade empilhadas verticalmente e ligeiramente sobrepostas, usada para comparar como uma distribuição muda ao longo de um conjunto ordenado de grupos.`)
};

const ja_ridge_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リッジラインプロット(ジョイプロット)は、縦に積み重ねて少しずつ重ね合わせた一連の密度曲線で、順序のあるグループ間で分布がどのように変化するかを比較するために使われます。`)
};

const zh_ridge_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`山脊图（joyplot）是一系列垂直层叠、略微重叠的密度曲线，用于比较分布在一组有序数据组之间的变化情况。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_faq_a1", locale)
	if (locale === "en") return en_ridge_faq_a1(inputs)
	if (locale === "es") return es_ridge_faq_a1(inputs)
	if (locale === "de") return de_ridge_faq_a1(inputs)
	if (locale === "nl") return nl_ridge_faq_a1(inputs)
	if (locale === "fr") return fr_ridge_faq_a1(inputs)
	if (locale === "it") return it_ridge_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_faq_a1(inputs)
	if (locale === "pt") return pt_ridge_faq_a1(inputs)
	if (locale === "ja") return ja_ridge_faq_a1(inputs)
	return zh_ridge_faq_a1(inputs)
};